module.exports = __webpack_public_path__ + "img/11_non_close_L3.6105a622.svg";